/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";

import {
  Select,
  Message,
  TextArea,
  InputField,
  PhoneInput,
  AddPageShell,
  AddSection,
} from "../components/Component";

import { codeOk, codeCreate, errorMessage } from "../../lib/index";

import { useTeamContext } from "../../context/TeamContext";
import { defaultImage } from "../../lib/libraries/imageKit/ImageKit";
import { ImageKitUpload } from "../../ui/ImageKitLibrary";
import { FOLDERS } from "../doseeData/utils/Utils";
import {
  FiUser,
  FiImage,
  FiPhone,
  FiMapPin,
  FiSettings,
  FiAlignLeft,
} from "react-icons/fi";

const Add = () => {
  const { createOneTeam } = useTeamContext();

  const [thumbnail, setThumbnail] = useState(defaultImage);
  const [thumbnailId, setThumbnailId] = useState("img_cdn_id");
  const [error, setError] = useState(false);
  const [status, setStatus] = useState(0);
  const [message, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [firstname, setFirstName] = useState(null);
  const [lastname, setLastName] = useState(null);
  const [country, setCountry] = useState(null);
  const [city, setCity] = useState(null);
  const [address, setAddress] = useState(null);
  const [phonenumber, setPhoneNumber] = useState(null);
  const [email, setEmail] = useState(null);
  const [role, setRole] = useState(null);
  const [description, setDescription] = useState(null);
  const [teamStatus, setTeamStatus] = useState(1);

  const teamRoutes = "/team";

  const cleanFields = () => {
    setLoading(false);
    setSuccess(true);
    setFirstName(null);
    setLastName(null);
    setCountry(null);
    setCity(null);
    setAddress(null);
    setPhoneNumber(null);
    setThumbnail(null);
    setThumbnailId(null);
    setDescription(null);
  };

  const responses = (isError: any, _status: any, _message: any) => {
    setError(isError);
    setStatus(_status);
    setErrorMessage(_message);
  };

  const addOneTeamHandler = async (e: any) => {
    e.preventDefault();
    setLoading(true);
    if (!thumbnail || !thumbnailId) {
      setLoading(false);
      return responses(true, 400, "Image Required");
    } else {
      await sendDBRequest();
    }
  };

  const sendDBRequest = async () => {
    const data = {
      email_address: email,
      firstname: firstname,
      lastname: lastname,
      password: "000000",
      country: country,
      city: city,
      address: address,
      phone_number: phonenumber,
      role: role,
      description: description,
      status: teamStatus,
      thumbnail: thumbnail ? thumbnail : defaultImage,
      image_cdn_id: thumbnailId ? thumbnailId : "...",
    };

    const response = await createOneTeam(data);
    if (response) {
      if (
        response.data.status === codeOk ||
        response.data.status === codeCreate
      ) {
        cleanFields();
        return responses(false, response.data.status, response.data.message);
      } else {
        setLoading(false);
        return responses(true, response.data.status, response.data.message);
      }
    } else {
      setLoading(false);
      return responses(true, 400, errorMessage);
    }
  };

  return (
    <AddPageShell
      backRoute={teamRoutes}
      eyebrow="Team • Members"
      title="Add Team Member"
      subtitle="Add someone to your public team page with photo, role and contact details."
      icon={<FiUser className="h-5 w-5" />}
      pills={[
        { label: "Status", value: teamStatus === 1 ? "Visible" : "Hidden" },
      ]}
      loading={loading}
      submitLabel="Add Member"
      onSubmit={addOneTeamHandler}
      onSubmitClick={() => {
        setError(false);
        setSuccess(false);
        setErrorMessage("");
      }}
      message={
        <Message
          props={{
            error: error,
            success: success,
            message: message,
            loading: loading,
            status: status,
            onClick: () => {
              setError(false);
              setSuccess(false);
              setErrorMessage("");
            },
          }}
        />
      }
    >
      <AddSection
        title="Profile Photo"
        hint="JPEG or PNG. Square photos look best."
        icon={<FiImage className="h-4 w-4" />}
      >
        <ImageKitUpload
          thumbnail={thumbnail}
          thumbnailId={thumbnailId}
          setThumbnail={setThumbnail}
          setThumbnailId={setThumbnailId}
          folder={FOLDERS.TEAM}
        />
      </AddSection>

      <AddSection
        title="Identity"
        hint="Name, role and address."
        icon={<FiUser className="h-4 w-4" />}
      >
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
          <InputField
            props={{
              id: "firstname",
              title: "First Name",
              type: "text",
              value: firstname ? firstname : "",
              onChange: (e: any) => {
                setFirstName(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <InputField
            props={{
              id: "lastname",
              title: "Last Name",
              type: "text",
              value: lastname ? lastname : "",
              onChange: (e: any) => {
                setLastName(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <InputField
            props={{
              id: "role",
              title: "Role",
              type: "text",
              value: role ? role : "",
              onChange: (e: any) => {
                setRole(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
        </div>
      </AddSection>

      <AddSection
        title="Location"
        hint="Where this teammate is based."
        icon={<FiMapPin className="h-4 w-4" />}
      >
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
          <InputField
            props={{
              id: "country",
              title: "Country",
              type: "text",
              value: country ? country : "",
              onChange: (e: any) => {
                setCountry(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <InputField
            props={{
              id: "city",
              title: "City",
              type: "text",
              value: city ? city : "",
              onChange: (e: any) => {
                setCity(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <InputField
            props={{
              id: "address",
              title: "Address",
              type: "text",
              value: address ? address : "",
              onChange: (e: any) => {
                setAddress(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
        </div>
      </AddSection>

      <AddSection
        title="Contact"
        hint="Phone and email."
        icon={<FiPhone className="h-4 w-4" />}
      >
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          <PhoneInput
            setPhone={setPhoneNumber}
            phone={phonenumber}
            required={true}
          />
          <InputField
            props={{
              id: "email",
              title: "Email Address",
              type: "email",
              required: true,
              value: email ? email : "",
              onChange: (e: any) => {
                setEmail(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
        </div>
      </AddSection>

      <AddSection
        title="Visibility & Bio"
        hint="Whether this member appears publicly, plus a short bio."
        icon={<FiSettings className="h-4 w-4" />}
      >
        <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
          <Select
            props={{
              id: "event_status",
              title: "Status",
              option: ["visible", "invisible"],
              onChange: (e: any) => {
                if (e.target.selectedIndex === 0) setTeamStatus(1);
                else setTeamStatus(0);
                setError(null);
                setSuccess(null);
              },
            }}
          />
        </div>
        <div className="mt-4">
          <div className="mb-2 flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.14em] text-gray-500">
            <FiAlignLeft className="h-3.5 w-3.5" />
            Bio
          </div>
          <TextArea
            props={{
              id: "description",
              title: "Description",
              type: "text",
              value: description ? description : "",
              onChange: (e: any) => {
                setDescription(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
        </div>
      </AddSection>
    </AddPageShell>
  );
};

export default Add;
